import * as React from "react";

import {
    CreateUpdateOccupationalIllness,
    OccupationalIllness
} from "../models";
import { OccupationalIllnessApi } from "../occupationalIllnessApi";

import { CreateEditModal } from "./CreateEditModal";

interface Props {
    occupationalIllness: CreateUpdateOccupationalIllness;
    onSaved: (occupationalIllness: OccupationalIllness) => void;
}

export const Edit: React.FunctionComponent<Props> = ({ onSaved, occupationalIllness }: Props) => {

    if (!occupationalIllness) {
        return <></>;
    }
    return (
        <CreateEditModal
            title="Edit Occupational Illness"
            occupationalIllness={occupationalIllness}
            onSaved={onSaved}
            saveModel={OccupationalIllnessApi.update}
        />
    );
};
